import { BellIcon } from "@heroicons/react/24/outline";
import { ReminderContext } from "contexts/reminder";
import React, { useCallback, useContext } from "react";

export const ReminderTrayItem: React.FC = () => {
    const { isReminderEnabled, setVisible, reminders } = useContext(ReminderContext);
    const remindersCount = reminders?.length || 0;

    const handleClick = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    if (!isReminderEnabled) {
        return null;
    }

    return (
        <button
            onClick={handleClick}
            className="relative p-1.5 rounded-lg hover:bg-zinc-950/5 dark:hover:bg-white/5 focus:outline-none"
            aria-label="Reminders">
            <BellIcon className="size-5 text-zinc-500" />
            {remindersCount > 0 && (
                <span className="absolute top-1 right-1 flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                </span>
            )}
        </button>
    );
};
